/**
 * Loads the CallWidget support embed while a marketing (public) page is mounted.
 * Kept out of index.html so the signed-in /app shell never gets the widget.
 */
import React, { useEffect } from 'react';

const EMBED_SCRIPT_ID = 'motzu-callwidget-embed';
const EMBED_SRC =
  'https://api.callwidget.co/embed?iID=eyJpdiI6Ik1Fa1hQbmM2UkJkNWdTVnBFRkxDbkE9PSIsInZhbHVlIjoiQjJWRU80czRFRldmYUJHcWJMSWhUQT09IiwibWFjIjoiMjVmNjM0YzAwOWU2ODc0MmRmYzhkMjgzNzM5ZjhjYjdiODllZDNjYmRiNTUxYmJhNjk3MGM2ZWY3ZjViOGE0NSIsInRhZyI6IiJ9';

const removeCallWidgetScripts = () => {
  document
    .querySelectorAll(
      `script#${EMBED_SCRIPT_ID}, script[src*="api.callwidget.co/"]`
    )
    .forEach((el) => el.remove());
};

export const CallWidget: React.FC = () => {
  useEffect(() => {
    if (document.getElementById(EMBED_SCRIPT_ID)) return;

    const script = document.createElement('script');
    script.id = EMBED_SCRIPT_ID;
    script.src = EMBED_SRC;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      removeCallWidgetScripts();
      // Best-effort cleanup of DOM the widget may have injected.
      document
        .querySelectorAll(
          'iframe[src*="callwidget"], [id*="callwidget"], [class*="callwidget"], [id*="CallWidget"], [class*="CallWidget"]'
        )
        .forEach((el) => el.remove());
    };
  }, []);

  return null;
};

export default CallWidget;
